'use client'

import { useEffect, useState } from 'react'
import { Sparkles, LineChart, BarChart3, Database, Check, BarChartIcon as ChartBar, FileText, FileSpreadsheet, Code, Book, PieChart, FileEdit, FileSearch, FileScan, Coins } from 'lucide-react'

function getAgentIcon(agent) {
  const iconClass = `h-4 w-4 text-white`
  
  switch (agent) {
    case 'Kessan Manager':
    case 'Tanshin Manager':
    case 'Stock Manager':
    case 'TD Manager':
    case 'Master Data Manager':
    case 'Kessan DB':
    case 'Yuho DB':
    case 'Yuho Text DB':
    case 'Tanshin DB':
    case 'Master Data DB':
    case 'Forecast Correction DB':
      return <Database className={iconClass} />
    case 'Dividend Manager':
        return <Coins className={iconClass} />
    case 'Graph Creator':
        return <LineChart className={iconClass} />
    case 'Graph Create Tool':
    case 'Graph Style Modify Tool':
      return <BarChart3 className={iconClass} />
    case 'Text Analyst':
    case 'Document Creator':
    case 'PDF List Getter':
    case 'PDF Getter':
      return <FileText className={iconClass} />
    case 'Yuho Manager':
      return <FileSearch className={iconClass} />
    case 'File Split':
        return <FileScan className={iconClass} />
    case 'Securities Code Getter':
    case 'Industry Code Getter':
      return <Code className={iconClass} />
    case 'Notebook':
      return <Book className={iconClass} />
    case 'THINK':
      return <SparklesIcon />
    default:
      return <PieChart className={iconClass} />
  }
}

function getArrowMessage(agent) {
  if (agent === 'Kessan Manager') return 'Getting Data ...'
  if (agent === 'Yuho Manager') return 'Searching Text ...'
  if (agent === 'Tanshin Manager') return 'Searching Text ...'
  if (agent === 'Stock Manager') return 'Getting Price Data ...'
  if (agent === 'TD Manager') return 'Searching Text ...'
  if (agent === 'Graph Creator') return 'Creating Graph ...'
  if (agent === 'Text Analyst') return 'Analyzing Text ...'
  if (agent === 'Document Creator') return 'Creating Document ...'
  if (agent === 'Master Data Manager') return 'Getting Data ...'
  if (agent === 'Securities Code Getter') return 'Getting Code ...'
  if (agent === 'Industry Code Getter') return 'Getting Code ...'
  if (agent === 'Kessan DB') return 'Getting Data From DB'
  if (agent === 'Yuho DB') return 'Getting Data From DB'
  if (agent === 'Yuho Text DB') return 'Getting Data'
  if (agent === 'Tanshin DB') return 'Getting Data ...'
  if (agent === 'Master Data DB') return 'Getting Data ...'
  if (agent === 'Graph Create Tool') return 'Drawing Graph'
  if (agent === 'Graph Style Modify Tool') return 'Modifying Graph'
  if (agent === 'Forecast Correction DB') return 'Getting Data ...'
  if (agent === 'PDF List Getter') return 'Getting Data ...'
  if (agent === 'PDF Getter') return 'Getting Data ...'
  if (agent === 'Notebook') return 'Analyzing Text'
  if (agent === 'File Split') return 'Splitting Long Text ...'
  if (agent === 'Dividend Manager') return 'Getting Dividend Data ...'
  return 'Processing...'
}

const addAgent = (agent, isLast) => {
  if (agent === 'FinChat Assistant') {
    return <SparklesIcon />
  } else {
    const message = getArrowMessage(agent)
    return (
      <div key={agent} className="flex flex-col items-center">
        <div className="flex items-center">
          <div className='mx-4 pt-2'>
              <div className="relative h-[2px] w-32">
                  <div className={`
                  absolute inset-0 bg-gray-300
                  `} />
                  {isLast && (
                  <div className="absolute inset-0 bg-gray-500 animate-progressLine" />
                  )}
              </div>
              <div className={`
                  mt-2 text-xs transition-all duration-300
                  ${isLast ? 'text-gray-500 font-medium scale-105' : 'text-gray-600'}
              `}>
                  {message}
              </div>
          </div>
          <div className="flex flex-col items-center">
            <div 
              className={`
                relative flex h-8 w-8 items-center justify-center rounded-full 
                transition-all duration-300 ease-in-out
                ${isLast ? 'bg-gray-600 scale-110' : 'bg-gray-600 scale-100'}
                ${isLast ? 'animate-pulse shadow-lg shadow-gray-200' : ''}
              `}
            >
              {getAgentIcon(agent)}
            </div>
          </div>
              
        </div>
      </div>
    )
  }
  
}

const SparklesIcon = () => {
  return (
    <>
      <Sparkles className="h-8 w-8 text-[#66cdaa] animate-blink h-[20px]] w-[20px]" />
      <style jsx global>{`
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
        .animate-blink {
          animation: blink 1.5s ease-in-out infinite;
        }
      `}</style>
    </>
  )
}

const ProcessBar = ({ agents }) => {
  return (
    <>
      <style jsx global>{`
        @keyframes progressLine {
          0% {
            transform: scaleX(0);
            transform-origin: left;
          }
          100% {
            transform: scaleX(1);
            transform-origin: left;
          }
        }
        .animate-progressLine {
          animation: progressLine 2.5s ease-in-out;
        }
      `}</style>
      <div className="flex flex-wrap gap-2 items-start p-2">
        {agents.map((agent, index) => (
          addAgent(
            agent,
            index === agents.length - 1
          )
        ))}
      </div>
    </>
  )
}

export default ProcessBar

